import { Component, input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexStroke,
  ApexAnnotations,
  NgApexchartsModule,
} from 'ng-apexcharts';

export type LineChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  annotations: ApexAnnotations;
  dataLabels: ApexDataLabels;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
};

@Component({
  selector: 'app-line-chart',
  imports: [NgApexchartsModule, FormsModule],
  templateUrl: './line-chart.html',
  styleUrl: './line-chart.scss',
})
export class LineChart {
  @ViewChild('chart') chart!: ChartComponent;

  data: number[] = [0];
  categories: string[] = ['Teste'];

  selectedRange = input<'today' | 'week' | 'month'>();
  chartOptions = input<LineChartOptions>({
    series: [
      {
        name: 'Faturamento',
        data: this.data,
      },
    ],
    chart: {
      type: 'line',
      height: 350,
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    annotations: {
      xaxis: [
        {
          x: 'hoje',
          strokeDashArray: 683.3774545748418,
          borderColor: '#FDCED1',
          label: {
            borderColor: '#FDCED1',
            style: {
              color: '#000',
              background: '#FDCED1',
            },
            text: 'Ontem',
          },
        },
      ],
    },
    xaxis: {
      categories: this.categories,
    },
    yaxis: {
      labels: {
        formatter: (value) => {
          return Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
            value / 100
          );
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 3,
      colors: ['#F47920'],
    },
    tooltip: {
      y: {
        formatter: (value) =>
          Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value / 100),
      },
      marker: {
        fillColors: ['#F47920'],
      },
    },
  });

  constructor() {}

  ngOnInit() {}
}
